import { polyfills, isObjectFitSupported } from './polyfills/polyfills';
import { yall } from './vendor/yall-v3.1.6';
import { init as menuInit } from './modules/menu';
import { init as headerSearchInit } from './modules/headerSearch';
import 'easy-toggle-state';
import { init as ageAndCookieConsentModalInit } from './modules/ageAndCookieConsentModal';
import { init as newsletterInit } from './modules/newsletter';
import { init as filterListInit } from './modules/recipeFilterList';
import { init as incrementalSearchInit } from './modules/incrementalSearch';
import { init as loadMoreInit } from './modules/loadmore';
import { cookiebot } from '../../../Static/js/common/cookiebot';

const start = () => {
  if (!isObjectFitSupported) {
    const objectFitElements = document.querySelectorAll(
      '.js-object-fit:not(.lazy)',
    );

    if (objectFitElements) {
      objectFitPolyfill(objectFitElements);
    }
  }

  yall({
    events: {
      load: function(event) {
        const element = event.target;

        if (!element.classList.contains('lazy') && element.nodeName == 'IMG') {
          element.classList.add('lazy--loaded');

          if (
            !isObjectFitSupported &&
            element.classList.contains('js-object-fit')
          )
            objectFitPolyfill(element);
        }
      },
    },
    observeChanges: true,
  });

  ageAndCookieConsentModalInit();
  filterListInit();
  menuInit();
  headerSearchInit();
  newsletterInit();
  incrementalSearchInit();
  loadMoreInit();
  cookiebot();
};

export const init = () => {
  if (!polyfills) {
    start();
  } else {
    Promise.all([...polyfills])
      .then(_ => {
        try {
          start();
        } catch (error) {
          console.error('Failed to start the app', error);
        }
      })
      .catch(error => {
        console.error('Failed fetching polyfills', error);
      });
  }
};

// eslint-disable-next-line no-unused-expressions
document.readyState !== 'loading'
  ? init()
  : document.addEventListener('DOMContentLoaded', init);
